module.exports = __webpack_public_path__ + "static/media/rfc_curp.4d9da257.svg";